import { FC, useState, ChangeEvent } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useQuery, useMutation } from 'react-query';
import { observer } from 'mobx-react-lite';
import { useStyles } from './styles';
import { Typography, Paper, Tabs, Tab, Grid } from '@material-ui/core';
import TabPanel from './../../../TabPanel';
import { Departments, Users, Groups } from './TabsContent';
import Button from '@material-ui/core/Button';
function a11yProps(index: string) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

export const MappingFields: FC = observer(() => {
  const {
    importStore: {
      setStep,
      mapping: { people, group, department },
      getLdapAttributePreferences,
    },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
    AppStore: { AttributePreferences },
  } = useStore();

  const getLdapAttributePreferencesReq = useQuery(
    'getLdapAttributePreferencesReq',
    () => getLdapAttributePreferences(),
    {
      onError: () => openNotification('error', `Can't get attribute`),
    }
  );

  const mapsync = useMutation(
    'AttributePreferences',
    () => {
      const infoData = getLdapAttributePreferencesReq?.data?.data;
      const attributes = infoData?.attributes || [];

      const payload = {
        app_name: 'ldap',
        attributes: attributes,
      };

      return AttributePreferences(payload);
    },
    {
      onMutate: () => {
        setStep('one_status');
      },
      onSuccess: () => {
        setStep('one');
        disablePreloader();
        openNotification('success', `Configuration is successfully updated.`);
      },
      onError: ({ message }: Error) => {
        setStep('two');
        openNotification('error', message);
      },
    }
  );

  useAppPreloader(mapsync.isLoading);

  const classes = useStyles();
  const [value, setValue] = useState<string>('one');

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };
  return (
    <div className={classes.box}>
      <Typography variant='body2' className={classes.textBox}>
        <p>Please map fields from your existing LDAP Directory (src) to EasyIdentity Cloud directory (destination).</p>
      </Typography>
      <Typography variant='body2' className={classes.textBox}></Typography>
      <Grid item xl className={classes.tabsPanel}>
        <Paper className={classes.tabsPaper}>
          <Tabs
            value={value}
            className={classes.tabs}
            TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
            onChange={handleChange}
          >
            {people !== null ? (
              <Tab value='one' wrapped label='Users' {...a11yProps('one')} className={classes.label} />
            ) : null}
            {group !== null ? (
              <Tab value='two' wrapped label='Groups' {...a11yProps('two')} className={classes.label} />
            ) : null}
            {department !== null ? (
              <Tab value='three' wrapped label='Departments' {...a11yProps('three')} className={classes.label} />
            ) : null}
          </Tabs>
          <div className={classes.tabBox}>
            {people !== null ? (
              <TabPanel value={value} index='one'>
                <Users />
              </TabPanel>
            ) : null}
            {group !== null ? (
              <TabPanel value={value} index='two'>
                <Groups />
              </TabPanel>
            ) : null}
            {department !== null ? (
              <TabPanel value={value} index='three'>
                <Departments />
              </TabPanel>
            ) : null}
          </div>
        </Paper>
      </Grid>
      <div className={classes.btnBox}>
        <Button className={classes.btn} onClick={() => setStep('one')}>
          Back
        </Button>
        <Button
          variant='contained'
          color='secondary'
          className={classes.btn}
          //  disabled={!isLoading ? false : true}
          onClick={() => mapsync.mutate()}
        >
          Next
        </Button>
      </div>
    </div>
  );
});
